export default function validate(fields) {
  const errors = {}
  const { displayName, clientId } = fields
  if (typeof displayName === 'undefined' || displayName === '') {
    errors.displayName = 'Client Name must not be empty'
  }

  if (typeof clientId === 'undefined' || clientId === '') {
    errors.clientId = 'Client Id must not be empty'
  } 
  if (/\s/.test(clientId)) {
    errors.clientId = 'Client Id must not contain spaces'
  }
  if (/[A-Z]/.test(clientId)) {
    errors.clientId = 'Client Id must not contain capital letters'
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/client-register-form/validate.js